import {isFeatureEnabled} from '@github-ui/feature-flags'
import {getFetchNonceHeaders} from '@github-ui/fetch-nonce'

export function getBaseFetchHeaders(nonceToValidate?: string) {
  let headers = {
    'X-Requested-With': 'XMLHttpRequest',
  }

  if (isFeatureEnabled('fetch_nonce_headers')) {
    headers = {
      ...headers,
      ...getFetchNonceHeaders(nonceToValidate),
    }
  }

  return headers
}

export function addBaseFetchHeaders(headers: Headers, nonceToValidate?: string) {
  const fetchHeaders = getBaseFetchHeaders(nonceToValidate)

  for (const [header, value] of Object.entries(fetchHeaders)) {
    headers.set(header, value)
  }
}
